/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MathInfinityIcon16Light } from './MathInfinityIcon16Light';
import { MathInfinityIcon16Regular } from './MathInfinityIcon16Regular';
import { MathInfinityIcon16Solid } from './MathInfinityIcon16Solid';
import { MathInfinityIcon20Light } from './MathInfinityIcon20Light';
import { MathInfinityIcon20Regular } from './MathInfinityIcon20Regular';
import { MathInfinityIcon20Solid } from './MathInfinityIcon20Solid';
import { MathInfinityIcon24Regular } from './MathInfinityIcon24Regular';
import { MathInfinityIcon24Solid } from './MathInfinityIcon24Solid';
import { MathInfinityIcon32Regular } from './MathInfinityIcon32Regular';
import { MathInfinityIcon64Regular } from './MathInfinityIcon64Regular';
var sizes = {
    16: {
        light: MathInfinityIcon16Light,
        regular: MathInfinityIcon16Regular,
        solid: MathInfinityIcon16Solid,
    },
    20: {
        light: MathInfinityIcon20Light,
        regular: MathInfinityIcon20Regular,
        solid: MathInfinityIcon20Solid,
    },
    24: {
        regular: MathInfinityIcon24Regular,
        solid: MathInfinityIcon24Solid,
    },
    32: {
        regular: MathInfinityIcon32Regular,
    },
    64: {
        regular: MathInfinityIcon64Regular,
    },
};
export var MathInfinityIcon = forwardRef('MathInfinityIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
